// 识别当前浏览器环境
export const os = (() => {
  const ua = window.navigator.userAgent;
  const isWindowsPhone = /Windows Phone/.test(ua);
  const isSymbian = /SymbianOS/.test(ua) || isWindowsPhone;
  const isAndroid = /Android/.test(ua);
  const isFireFox = /Firefox/.test(ua);
  const isSafari = /Safari/.test(ua);
  const isTablet = /iPad|PlayBook/.test(ua)
    || (isAndroid && !/Mobile/.test(ua))
    || (isFireFox && /Tablet/.test(ua));
  const isIPhone = /iPhone/.test(ua) && !isTablet;
  const isPc = !isIPhone && !isAndroid && !isSymbian;
  const isMobileDaxiang = /dx\/com\.meituan|xmpp\//.test(ua);
  const isPCDaxiang = /DXShell/.test(ua);
  return {
    isTablet,
    isIPhone,
    isAndroid,
    isPc,
    isSafari,
    isMobileDaxiang,
    isPCDaxiang
  };
})();
